<template>
	<b-modal class="modal-lg" id="ModalDeleteCustomers" :title="deleteCustomersModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetModal('main')">
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light">{{ deleteCustomersModal.modalData.title }} ?</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
		</template>
		<template slot="default">
			<div class="row modal-body-log">
				<div v-if="this.$parent.selectedCustomers.length > 0" class="col-lg-12 py-2"><span>{{ t('deleteCustomersModalQuestion', 'deleteCustomersModalQuestion') }} </span>?</div>
			</div>
		</template>
		<template slot="modal-footer" slot-scope="{ ok, cancel }">
			<b-button variant="danger" @click="deleteSelectedCustomers(), ok()">Delete</b-button>
			<b-button variant="secondary" @click="cancel()">Cancel</b-button>
		</template>
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'ModalDeleteCustomers',
	
  inject: [
    'resetModal'
  ],
  components:{
    ResponseInfo
	},
  data () {
    return {
			deleteCustomersModal: {}
    }
	},
  computed:{
    ...mapGetters(['getResponseInfo'])
	},
	methods: {
    //NS-9783 SP delete selected customers
    deleteSelectedCustomers() {
      this.$parent.isBusy = true
      if(this.deleteCustomersModal.modalData.selectedCustomers.length > 0) {
        this.$store.dispatch('manageCustomersStore/deleteSelectedCustomers', {
          customerIds: this.deleteCustomersModal.modalData.selectedCustomers,
        }).then(() => {
          this.$parent.isBusy = false 
          this.$parent.selectAll = 0
					this.$parent.uncheckAllCustomers()
          this.$parent.requestCustomersList()
        })
      }
    },
	},
  created() {
		this.deleteCustomersModal = this.$attrs.modal
  },		
}
</script>

<style scoped>

</style>